import { render, staticRenderFns } from "./pnt.vue?vue&type=template&id=39d3ca25&scoped=true&"
import script from "./pnt.vue?vue&type=script&lang=js&"
export * from "./pnt.vue?vue&type=script&lang=js&"
import style0 from "./pnt.vue?vue&type=style&index=0&id=39d3ca25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d3ca25",
  null
  
)

export default component.exports